<div class="container">
    <h1>Welcome to Five</h1>
    @for(item of componentsToLoad;track $index)
    {
        <ng-container *ngComponentOutlet="item.component; inputs: { data: item.data }">
        </ng-container>
    }
</div>
